export default __webpack_public_path__ + "static/media/caringforchildren.7c801091.png";